<section class="page">

  <!-- HERO -->
  <header class="hero">
    <div class="hero__bg">
      <div class="hero__orb hero__orb--primary"></div>
      <div class="hero__orb hero__orb--secondary"></div>
    </div>
    <div class="hero__content">
      <div class="hero__kicker">Comparison</div>
      <h1 class="hero__title">Partiri vs Render</h1>
      <p class="hero__subtitle">
        Partiri is a European-first PaaS: every live region sits inside the EU today, pricing is a
        fixed monthly rate per pod with no subscription tiers, and deployment works from Git, a
        container registry, the CLI, or an MCP server for AI agents. Render is a broader, longer-established
        platform with more regions worldwide and its own managed database offering. Here is how the two
        compare, row by row.
      </p>
    </div>
  </header>

  <!-- COMPARISON TABLE -->
  <section class="section">
    <div class="section__head">
      <h2 class="section__title">Partiri vs Render, feature by feature</h2>
    </div>

    <div class="compare-table-wrap">
      <table class="compare-table">
        <caption>Comparison of Partiri and Render across data residency, pricing, runtimes, storage, deployment workflow, and free tier</caption>
        <thead>
          <tr>
            <th scope="col">Category</th>
            <th scope="col">Partiri</th>
            <th scope="col">Render</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row" data-label="Category">Data residency &amp; regions</th>
            <td class="compare-table__partiri" data-label="Partiri">
              Live in Germany (Nuremberg) and Finland (Helsinki) today; every region on the public
              roadmap is a European country, with 46 targeted in total.
            </td>
            <td data-label="Render">
              Regions across North America, Europe, and Asia, with a European region in Frankfurt,
              Germany.
            </td>
          </tr>
          <tr>
            <th scope="row" data-label="Category">Pricing model</th>
            <td class="compare-table__partiri" data-label="Partiri">
              Pick a pod size (vCPU + RAM + storage bundle) and pay a fixed monthly rate for it &mdash;
              no subscription tiers or platform fee. New accounts start with signup credit.
            </td>
            <td data-label="Render">
              Per-service instance plans that scale with CPU and memory, plus usage-based charges for
              some resources. Check render.com/pricing for current numbers.
            </td>
          </tr>
          <tr>
            <th scope="row" data-label="Category">Supported runtimes</th>
            <td class="compare-table__partiri" data-label="Partiri">
              Native support for Node.js, Deno, Python, Go, Rust, Ruby, Elixir, PHP, JVM (Java/Kotlin),
              .NET, and C++, plus static sites or any Docker image.
            </td>
            <td data-label="Render">
              Native runtimes for a similar set of common languages, plus Docker images for anything
              else.
            </td>
          </tr>
          <tr>
            <th scope="row" data-label="Category">Persistent storage</th>
            <td class="compare-table__partiri" data-label="Partiri">
              Persistent disks (1&ndash;10 GB) attachable to web services and private services, provisioned
              in the same EU region as the workload that uses them, plus Managed PostgreSQL
              databases (single-instance, EU-hosted, private in-cluster networking) &mdash; no
              backups, point-in-time recovery, or high availability yet.
            </td>
            <td data-label="Render">
              Persistent disks attachable to services, plus a separate managed database offering
              (Postgres, Redis/Key Value) run by the platform.
            </td>
          </tr>
          <tr>
            <th scope="row" data-label="Category">Deployment workflow</th>
            <td class="compare-table__partiri" data-label="Partiri">
              Git push (GitHub, GitLab, Bitbucket, Codeberg), a container registry (GHCR, GitLab
              Container Registry, Docker Hub, Artifact Registry, ECR), the <code>partiri</code> CLI, or
              a hosted MCP server for AI coding agents.
            </td>
            <td data-label="Render">
              Git push (GitHub, GitLab), Docker images from a registry, a CLI, and Blueprint
              (render.yaml) files for infrastructure-as-code.
            </td>
          </tr>
          <tr>
            <th scope="row" data-label="Category">Free tier / trial credit</th>
            <td class="compare-table__partiri" data-label="Partiri">
              Every new account starts with &euro;4 in credit &mdash; enough to run a Nano pod free for
              the first month.
            </td>
            <td data-label="Render">
              A free tier exists for some service types with usage limits; check render.com for current
              terms.
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <p class="footnote">
      Render details reflect publicly available documentation at the time of writing. Pricing and
      feature availability change &mdash; confirm current specifics on render.com before switching.
    </p>
  </section>


  <!-- MIGRATION CTA -->
  <section class="section">
    <div class="cta-band">
      <h2 class="cta-band__title">Moving from Render to Partiri?</h2>
      <p class="cta-band__desc">
        Your build command, start command, and environment variables transfer as-is. If you use a
        Dockerfile, it works unchanged. See the full migration guide for the details.
      </p>
      <div class="cta-band__actions">
        <a mat-flat-button routerLink="/migrate/render" class="btn-primary">
          <mat-icon>swap_horiz</mat-icon>
          Migration guide
        </a>
        <a mat-outlined-button routerLink="/documentation/start" class="btn-ghost">
          <mat-icon>rocket_launch</mat-icon>
          Deploy your first app
        </a>
      </div>
    </div>
  </section>

</section>
